const WISHLIST_STORAGE_KEY = 'dogsee_wishlist_handles';

function readWishlist() {
  try {
    const raw = localStorage.getItem(WISHLIST_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((value) => typeof value === 'string' && value.length > 0);
  } catch {
    return [];
  }
}

function writeWishlist(items) {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(Array.from(new Set(items))));
}

function getHandleFromUrl(urlValue) {
  if (!urlValue) return '';
  const match = urlValue.match(/\/products\/([^/?#]+)/);
  return match?.[1] ?? '';
}

function getHandleFromToggle(toggle) {
  if (!(toggle instanceof HTMLElement)) return '';
  if (toggle.dataset.productHandle) return toggle.dataset.productHandle;

  const productCard = toggle.closest('product-card');
  if (productCard) {
    const productLink = productCard.querySelector('a[href*="/products/"]');
    const handle = getHandleFromUrl(productLink?.getAttribute('href') ?? '');
    if (handle) return handle;
  }

  return getHandleFromUrl(window.location.pathname);
}

function updateWishlistBadge(count) {
  const badge = document.querySelector('[data-wishlist-count-bubble]');
  const counter = document.querySelector('[data-wishlist-count]');
  if (!(badge instanceof HTMLElement) || !(counter instanceof HTMLElement)) return;

  counter.textContent = `${count}`;
  badge.hidden = count === 0;
}

function setToggleVisualState(toggle, isActive) {
  if (!(toggle instanceof HTMLElement)) return;

  toggle.classList.toggle('is-active', isActive);
  toggle.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');

  const glyph = toggle.querySelector('.product-card-wishlist__glyph');
  if (glyph && !glyph.querySelector('svg')) {
    glyph.textContent = isActive ? '♥' : '♡';
  }
}

function syncToggleStates() {
  const liked = new Set(readWishlist());
  document.querySelectorAll('[data-wishlist-toggle]').forEach((toggle) => {
    const handle = getHandleFromToggle(toggle);
    setToggleVisualState(toggle, Boolean(handle) && liked.has(handle));
  });

  updateWishlistBadge(liked.size);
}

function toggleWishlist(handle) {
  if (!handle) return;

  const current = readWishlist();
  const set = new Set(current);
  if (set.has(handle)) {
    set.delete(handle);
  } else {
    set.add(handle);
  }

  writeWishlist(Array.from(set));
  syncToggleStates();
  animateWishlistHeader();
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: set.size } }));
}

function animateWishlistHeader() {
  const headerWishlist = document.querySelector('.header-actions__wishlist');
  if (!(headerWishlist instanceof HTMLElement)) return;

  headerWishlist.classList.add('is-animating');
  window.setTimeout(() => headerWishlist.classList.remove('is-animating'), 260);
}

function animateFlyToWishlist(sourceEl) {
  const destination = document.querySelector('.header-actions__wishlist');
  if (!(sourceEl instanceof HTMLElement) || !(destination instanceof Element)) return;

  const sourceRect = sourceEl.getBoundingClientRect();
  const destinationRect = destination.getBoundingClientRect();
  const heart = document.createElement('span');
  heart.className = 'wishlist-fly-heart';
  heart.textContent = '♥';
  heart.style.left = `${sourceRect.left + sourceRect.width / 2}px`;
  heart.style.top = `${sourceRect.top + sourceRect.height / 2}px`;
  document.body.appendChild(heart);

  const travelX = destinationRect.left + destinationRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
  const travelY = destinationRect.top + destinationRect.height / 2 - (sourceRect.top + sourceRect.height / 2);

  const animation = heart.animate(
    [
      { transform: 'translate(-50%, -50%) scale(0.9)', opacity: 0.95 },
      { transform: `translate(calc(-50% + ${travelX * 0.6}px), calc(-50% + ${travelY * 0.6}px)) scale(1.1)`, opacity: 1 },
      { transform: `translate(calc(-50% + ${travelX}px), calc(-50% + ${travelY}px)) scale(0.55)`, opacity: 0.7 },
    ],
    { duration: 520, easing: 'cubic-bezier(0.22, 0.8, 0.25, 1)', fill: 'forwards' }
  );

  animation.finished.finally(() => heart.remove());
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const toggle = target.closest('[data-wishlist-toggle]');
  if (!(toggle instanceof HTMLElement)) return;

  event.preventDefault();
  animateFlyToWishlist(toggle);
  const handle = getHandleFromToggle(toggle);
  toggleWishlist(handle);
});

window.addEventListener('storage', (event) => {
  if (event.key === WISHLIST_STORAGE_KEY) {
    syncToggleStates();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncToggleStates);
} else {
  syncToggleStates();
}
